import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import AddBoxIcon from '@material-ui/icons/AddBox';
import LinearProgress from '@material-ui/core/LinearProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import { Framework } from '@flint/framework';
import { inject, observer } from 'mobx-react';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        padding: theme.spacing(4),

    },
    paper: {
        width: '100%',
        height: "100%",
    },
    formTextField: {
        margin: theme.spacing(2, 0),
    },
    formControl: {
        width: "100%",
        margin: theme.spacing(2, 0),
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    formButton: {
        color: "#FFF",
        padding: "15px",
        margin: theme.spacing(2, 0),
        fontSize: "18px",
        fontFamily: "Nunito Sans",
        fontStyle: "normal",
        fontWeight: "bold",
        lineHeight: "20px",
        background: "#222747",
        borderRadius: "3px",
        textTransform: "uppercase",
        transition: "background 0.25s",
        border: "2px solid #222747",
        "&:hover": {
            background: "none",
            color: "#222747",
        },
    },
    formTitle: {
        fontFamily: "Merriweather",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "28px",
        lineHeight: "90px",
        color: "#222747",
    },
}));

const EditSubscriptionForm=({EPubStore, AddSubscriptionStore, AddSubscriptionStoreStatus, GetSubscriptionStore, EditSubscriptionStore, EditSubscriptionStoreStatus})=>{

    const classes = useStyles();
    const [page,setPage] = React.useState("Add");
    const [ePubs, setEPubs] = React.useState([]);
    const [addDialogOpen, setAddDialogOpen] = React.useState(false);
    const [editDialogOpen, setEditDialogOpen] = React.useState(false);
    const [subs, setSubs] = React.useState({});
    const [errors, setErrors] = React.useState({});

    const handleChange = (event) => {
        const key = event.target.name;
        const val=typeof event.target.value === "object"?event.target.value:(event.target.type === "number" ? Number(event.target.value) : event.target.value.trim());
        
        setSubs(prevState => {
            return { ...prevState, [key]: val, currency: "USD" }
        })
    }

    const handleSwitchChange = (event)  => {
        const key = event.target.name;
        setSubs(prevState => {
            return { ...prevState, [key]: !prevState[key] }
        })
    }

    const validate = () => {
        let temp = {}
        temp.sku = subs.sku ? "":"Please enter a SKU.";
        temp.productCode = subs.productCode ? "":"Please enter a product code.";
        temp.name = subs.name ? "":"Please enter a name.";
        temp.price = subs.price ? "":"Please enter a price.";
        temp.tenure = subs.tenure ? "":"Please select a tenure.";
        temp.description = subs.description ? "":"Please enter a description.";
        temp.isbns = subs.isbns && subs.isbns.length >= 1 ? "":"Please select a isbn.";
        setErrors({...temp})
        return Object.values(temp).every(x => x == "")
    }

    const handleAddSubscription = () => {
        if(validate()) {
            Framework.sendEvent("ADDING_SUBSCRIPTION_DATA", subs);
            setAddDialogOpen(true);
        }
    }

    const handleEditSubscription = () => {
        if(validate()) {
            Framework.sendEvent("EDITING_SUBSCRIPTION_DATA", subs);
            setEditDialogOpen(true);
        }
    }

    const handleAddDialogClose = () => {
        setAddDialogOpen(false);
        if(!AddSubscriptionStoreStatus.isError)
            Framework.redirect('/subscriptions');
    }

    const handleEditDialogClose = () => {
        setEditDialogOpen(false);
        if(!EditSubscriptionStoreStatus.isError)
            Framework.redirect('/subscriptions');
    }

    React.useEffect(() => {
        document.title = page === "Add" ? "Add Subscription" : "Edit Subscription";
        if(page === "Edit") {
            Framework.sendEvent("FETCHING_SUBSCRIPTION_DATA", `${window.location.pathname.split("/")[2]}`);
            setSubs(GetSubscriptionStore);
        }
    },[page])

    React.useEffect(() => {
        const href=window.location.href.split("/")[3].split("-")[0];
        setPage(href.charAt(0).toUpperCase() + href.slice(1));
        
        EPubStore.fetch();
        setEPubs(EPubStore.epubs);
    },[])

    return(
        <>
        {AddSubscriptionStoreStatus.isPending ? <LinearProgress color="secondary" /> : <Dialog
            open={addDialogOpen}
            onClose={handleAddDialogClose}
            aria-labelledby="sync-dialog-title"
            aria-describedby="sync-dialog-description"
        >
            <DialogTitle id="sync-dialog-title">Add Subscription</DialogTitle>
            <DialogContent>
                <DialogContentText id="sync-dialog-description">
                    {AddSubscriptionStore.res}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleAddDialogClose} color="primary">
                    OK
                </Button>
            </DialogActions>
        </Dialog>}
        {EditSubscriptionStoreStatus.isPending ? <LinearProgress color="secondary" /> : <Dialog
            open={editDialogOpen}
            onClose={handleEditDialogClose}
            aria-labelledby="sync-dialog-title"
            aria-describedby="sync-dialog-description"
        >
            <DialogTitle id="sync-dialog-title">Edit Subscription</DialogTitle>
            <DialogContent>
                <DialogContentText id="sync-dialog-description">
                    {EditSubscriptionStore.res}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleEditDialogClose} color="primary">
                    OK
                </Button>
            </DialogActions>
        </Dialog>}
        <div className={classes.root}>
            <Grid container spacing={3} justify="center">
                <Grid item xs={12} sm={10} md={8} lg={6}>
                    <Paper className={classes.paper}>
                        <form className={classes.root}>
                            <Typography className={classes.formTitle} variant="h1" id="tableTitle" component="div">{page} Subscription</Typography>
                            <TextField className={classes.formTextField} id="sku" label="SKU" name="sku" required value={subs.sku ? subs.sku : ""} disabled={page === "Add" ? false : true} variant="outlined" fullWidth onChange={handleChange}
                            {...(errors.sku && {error: true, helperText: errors.sku})} />
                            <TextField className={classes.formTextField} id="productCode" label="Product Code" name="productCode" required value={subs.productCode ? subs.productCode : ""} disabled={page === "Add" ? false : true} variant="outlined" fullWidth onChange={handleChange}
                            {...(errors.productCode && {error: true, helperText: errors.productCode})} />
                            <TextField className={classes.formTextField} id="name" label="Name" name="name" required value={subs.name ? subs.name : ""} variant="outlined" fullWidth onChange={handleChange}
                            {...(errors.name && {error: true, helperText: errors.name})} />
                            <FormControl fullWidth className={classes.formControl} variant="outlined" required
                            {...(errors.price && {error: true})}>
                                <InputLabel htmlFor="price">Price</InputLabel>
                                <OutlinedInput
                                    id="price"
                                    name="price"
                                    value={subs.price ? subs.price : ""}
                                    startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                    labelWidth={40}
                                    type="number"
                                    onChange={handleChange}
                                />
                                {errors.price && <FormHelperText>{errors.price}</FormHelperText>}
                            </FormControl>
                            <FormControl variant="outlined" className={classes.formControl} required
                            {...(errors.tenure && {error: true})}>
                                <InputLabel htmlFor="tenure">Tenure</InputLabel>
                                <Select label="tenure" name="tenure" value={subs.tenure ? subs.tenure : ""} onChange={handleChange}>
                                    <MenuItem key="Monthly" value="Monthly">
                                        Monthly
                                    </MenuItem>
                                    <MenuItem key="Quarterly" value="Quarterly">
                                        Quarterly
                                    </MenuItem>
                                    <MenuItem key="Semi-Anually" value="Semi-Anually">
                                        Semi-Anually
                                    </MenuItem>
                                    <MenuItem key="Anually" value="Anually">
                                        Anually
                                    </MenuItem>
                                </Select>
                                {errors.tenure && <FormHelperText>{errors.tenure}</FormHelperText>}
                            </FormControl>
                            <TextField className={classes.formTextField} id="description" label="Description" name="description" required value={subs.description ? subs.description : ""} variant="outlined" fullWidth multiline rows="4" onChange={handleChange}
                            {...(errors.description && {error: true, helperText: errors.description})} />
                            <FormControl className={classes.formControl} required
                            {...(errors.isbns && {error: true})}>
                                <InputLabel id="selectISBNs">ISBNs</InputLabel>
                                <Select labelId="selectISBNLabel" id="selectISBNs" multiple name="isbns"
                                value={subs.isbns ? [...subs.isbns] : []} input={<Input id="selectISBNInput" />} onChange={handleChange}
                                    renderValue={(isbns) => (
                                        <div className={classes.chips}>
                                            {isbns.map((isbn) => (
                                                <Chip key={isbn} label={isbn} className={classes.chip} />
                                            ))}
                                        </div>
                                    )}
                                >
                                    {ePubs.map((ePub) => (
                                        <MenuItem key={ePub.isbn} value={ePub.isbn}>
                                            {ePub.isbn}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {errors.isbns && <FormHelperText>{errors.isbns}</FormHelperText>}
                            </FormControl>
                            <FormControlLabel className={classes.formControlLabel}
                                control={<Switch checked={subs.active ? true : false}
                                name="active" value={subs.active ? true : false}
                                onChange={handleSwitchChange} />} label="Active Subscription" />
                            <Box display="flex" justifyContent="flex-end">
                                <Button className={classes.formButton} variant="contained" color="primary"
                                startIcon={page==="Add" ? <AddBoxIcon /> : <SaveIcon />}
                                onClick={page==="Add" ? handleAddSubscription : handleEditSubscription}>
                                    {page==="Add" ? "Add" : "Save"} Subcription
                                </Button>
                            </Box>
                        </form>
                    </Paper>
                </Grid>
            </Grid>
        </div>
        </>
    )
}

export default inject('EPubStore','AddSubscriptionStore','AddSubscriptionStoreStatus','GetSubscriptionStore','EditSubscriptionStore','EditSubscriptionStoreStatus')(observer(EditSubscriptionForm));